export default __webpack_public_path__ + "static/media/advisor.d9438be6.svg";